import React from "react";
import "./FAQ.css";

/**
 * Uses Tailwind CSS for styling
 * Tailwind file is imported in App.css
 */

export default function FAQ() {
  return (
    <div className="larger-font app min-h-screen text-blue-200 flex flex-col p-20">

<div style={{ display: "flex", justifyContent: "center" }}>
     <a href="/">
  <img
    src="/jupiter.png"
    url="/"
    alt="Jupiter"
    style={{
      width: "280px",
      height: "auto",
      cursor: "pointer"
    }}
  />
  </a>
</div>

    <div className="question">
      What is the Background Bank Interpretation?
    </div>
     <div className="about-text">
The Background Interpretation is a new interpretation of quantum mechanics and more broadly an exciting programme of research for uniting relativity and quantum mechanics. It has numerous advantages over contemporary interpretations of quantum mechanics. It is pictorial, intuitive, it addresses numerous unresolved questions like the problem of measurement, and rather than isolating quantum mechanics from the rest of physics, as other interpretations do, its unity with relativity is baked in. And there are even more advantages than this.
    </div>
        <div className="question">
      Was it done with AI? Is it an AI theory?
    </div>
      <div className="about-text">
No. This has been in the works for 15 years. My first attempt at an interpretation of quantum mechanics, a paper entitled "Definite Outcomes in Quantum Mechanics", which I submitted in 2011, contains some of the key ideas: like the Background Bank Interpretation, it is a deterministic theory with nonlocal synchronisation; definite outcomes are defined such that they lead to a cascade, an informational stream to the macroscopic world, just like in the Background Bank. Classicality was interpreted as a kind of critical mass of cascade-producing interactions, so that anything in a classical "bath" would produce its own cascade. </div>   
          <div className="about-text">
            Unfortunately, this initial theory wasn't quite convincing; I had to propose modifications of quantum mechanics which were rather <i>ad hoc</i>. It became increasingly clear that it was impossible to resolve with known results.
          </div>
        <div className="about-text">
Since 2012 I have been evolving a new theory. The idea for the "Background Bank", which unified my ideas, occurred to me two or three years ago. Since I was working full time in IT, it was difficult to find time to write up my ideas. I quit my job over a year ago to be self-employed and that left me with some more free time to write the paper. AI wasn't used for anything other than a tool for help with the existing literature.
          </div>
            <div className="question">
      What is the Theory of Polytypes?
    </div>
         <div className="about-text">
    The Theory of Polytypes, which was written and submitted in February 2023, is the first serious mathematical theory of consciousness. Technically, there is something called Integrated Information Theory, which purports to be a mathematical theory of consciousness, but its central idea can essentially be reduced to: "The more tangled something is, the higher its consciousness value; the higher its consciousness value, the more conscious it is". This falls into a class of theory that I dismissed very early on. Actually, the parts of IIT that are best and more defensible, are better explained in the Theory of Polytypes.
          </div>
                   <div className="question">
          But these people have higher formal academic credentials than you. Surely that proves you're wrong?

                   </div>
                   <div className="about-text">
                    No. This is a misconception and a rather medieval, hierarchal idea. There is a long history in science of outsiders and amateurs making substantial contributions. (For example, I could name William Smith, the canal surveyor, discoverer of the principle of faunal succession and father of geology. But then you set yourself up to the retort: "He's comparing himself to William Smith".) The claim that scientific work today requires more knowledge, therefore it is impossible for amateurs to make an impact, is based on a fallacy. It assumes that the knowledge required to do valuable work, is an ever increasing quantity. In fact, due to the reusability of ideas, it is untrue that scientific work today requires more knowledge. If it does outwardly <i>appear</i> to require more knowledge, that is a function of professional gamesmanship and status-jockeying, rather than any constraint imposed by the world.  
                   </div>
                   <div className="about-text">
                    There are some occasions when you would have to reinvent the wheel, and some occasions when you can save yourself a lot of time by working from a clean slate. I always suspected this and I learned that it's indisputably true from working in IT.
                   </div>
                         <div className="question">
                          What are you hoping to get out of this?
                         </div>
                           <div className="about-text">
                            Right now, I would just like the credit which I think I have earned for creating two legitimate, original theories about important topics in science. I think anyone from within the hierarchy, if they produced such work, would meet with quite a different reception.
                           </div>
            
{/* <div>
  Throughout this time I have had to deal with the most tremendous prejudice in our society against amateur researchers. There is an unjustified presumption that giving any space to people without the correct sheepskin, would be like opening the gates and allowing barbarians to run untrammeled. There is such an ignoble, status-preserving motive at the root of this behaviour, which uses faux concerns of the greater good of science, as a pretext. 
</div> */}
{/* <div className="about-text">  
The reality is that for more than half of the history of science, since Galileo, more than half of the most important researchers were amateurs. It is true that in the last century, many scientific fields reached such a degree of technical sophistication, that it was rare for amateurs to make contributions.</div> */}


  <br/>
    </div>
  );
}

